import { InjectionToken } from "@angular/core";

export const CREDIT_CARDS_BASE_URL = new InjectionToken<string>("CREDIT_CARDS_BASE_URL");
